export interface ReportMetadata {
  readonly reportCategories: ReportCategories;
}

export interface ReportCategories {
  readonly [key: string]: ReportCategory;
}

export interface ReportCategory {
  readonly id: string;
  readonly name: string;
  readonly reportTypeList: Array<ReportType>;
  readonly nuxLabel: string | null | undefined;
  readonly tags?: Array<Tag>;
  readonly tooltip?: string;
}

export interface ReportType {
  readonly id: string;
  readonly name: string;
  readonly filterTypes: Array<string>;
  readonly reportPeriodMaxLookBack: ReportPeriodMaxLookBack;
  readonly taktReportType: string;
  readonly templateGuidance: string;
  readonly templateId: string;
  readonly timeUnits: Array<TimeUnit>;
  readonly nuxLabel: string | null | undefined;
  readonly tags?: Array<Tag>;
  readonly tooltip: string | null | undefined;
  readonly hmhGuid: string | null | undefined;
  readonly isCustomReport: boolean | null | undefined;
  readonly reportDescription: string | null | undefined;
}

export interface TimeUnit {
  readonly id: string;
  readonly name: string;
}

export interface Tag {
  readonly description: string;
  readonly id: string;
  readonly label: string;
}

export interface ReportPeriodMaxLookBack {
  maxLookBackDate: string | null | undefined;
  maxLookBackDays: number | null | undefined;
}

export enum ReportMetadataStatus {
  UNINITIALIZED,
  LOADING,
  SUCCESS,
  ERROR
}

export interface ErrorResponse {
  readonly status: number;
  readonly data: string;
}

//***----------------------- Custom Report Metadata types --------------------------***//

export interface CustomReportMetadata {
  readonly customReportType: CustomReportType;
}

export interface CustomReportType {
  readonly id: string;
  readonly name: string;
  readonly filterTypes: Array<string>;
  readonly reportPeriodMaxLookBack: ReportPeriodMaxLookBack;
  readonly taktReportType: string;
  readonly timeUnits: Array<CustomTimeUnit>;
  readonly nuxLabel: string | null;
  readonly tags?: Array<Tag>;
  readonly hmhGuid: string | null | undefined;
  readonly columns: Array<Column>;
  readonly facets: Array<Facet>;
  readonly reportDescription: string | null | undefined;
  readonly translationsMap?: Map<string, string>;
}

export interface CustomTimeUnit {
  readonly id: string;
  readonly name: string;
  readonly requiredColumns: Array<Column>;
}

export interface Column {
  readonly id: string;
  readonly name: string | null;
  readonly tooltip: string | null;
  readonly category: Array<string>;
}

export interface Facet {
  readonly id: string;
  readonly type: string;
  readonly name: string;
  readonly description: string | null | undefined;
  readonly options: Array<FacetOption>;
}

export interface FacetOption {
  readonly id: string;
  readonly name: string;
  readonly tooltip: string | null;
  readonly requiredColumns: Array<Column>;
  readonly additionalColumns: Array<Column>;
  readonly featureOverride: FeatureOverride;
}

export interface FeatureOverride {
  readonly reportPeriodMaxLookBack: ReportPeriodMaxLookBack | null;
  readonly maxReportingPeriod: MaxReportingPeriod | null;
  readonly unavailableColumns: Array<Column>;
}

export interface MaxReportingPeriod {
  readonly maxReportingDays: number | null | undefined;
}

export interface CustomReportDataQueryParams {
  readonly reportCategory: string;
  readonly reportType: string;
}

export enum FacetEnum {
  TIME_UNIT = 'timeunit',
  COV = 'cov',
  MTA = 'mta'
}
